import { evaluationsApi, nominationsApi, type AwardReadApi } from './praiseApi';

/**
 * Which of PRAISE's two surfaces a page is drawn for. **Evaluation is a VIEW of Nomination's
 * records** (the Deliberate shape): the same index, award profile and nominee profile, handed the
 * surface's own READ endpoints and key. A page asks `writes` before drawing any NOMINATION write
 * control — on Evaluation there is none, and its server has no route that would take one. Evaluation's
 * ONE write, the caller's own score sheet, is its own (`award-evaluations.score`) and is not a `writes`.
 */
export interface PraiseSurface {
  key: 'nomination' | 'evaluation';
  /** The module whose History Logs and Clear data the shell scopes to. */
  module: 'award-nominations' | 'award-evaluations';
  readPermission: string;
  /** Route root — `/praise/nominations` or `/praise/evaluations`. */
  basePath: string;
  /** The crumb and sidebar label. */
  label: string;
  api: AwardReadApi;
  /** True where the surface may create, edit, delete and upload — Nomination alone. */
  writes: boolean;
}

export const NOMINATION_SURFACE: PraiseSurface = {
  key: 'nomination',
  module: 'award-nominations',
  readPermission: 'award-nominations.read',
  basePath: '/praise/nominations',
  label: 'Nomination',
  api: nominationsApi,
  writes: true,
};

export const EVALUATION_SURFACE: PraiseSurface = {
  key: 'evaluation',
  module: 'award-evaluations',
  readPermission: 'award-evaluations.read',
  basePath: '/praise/evaluations',
  label: 'Evaluation',
  api: evaluationsApi,
  writes: false,
};
